export default __webpack_public_path__ + "static/media/businesscoffe.f50ed23b.webp";